
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"474 272.138 12 15.724"}},[_c('path',{attrs:{"filter":"url(#filter-blur)","fill":"#1D1D1B","d":"M480.005 273.138a5.007 5.007 0 0 0-5.005 5.005c0 3.138 2.223 4.145 4.108 6.77.659.915.887 1.949.887 1.949s.238-1.043.887-1.949c1.894-2.626 4.117-3.632 4.117-6.77a5.003 5.003 0 0 0-4.994-5.005z"}})])
      }
    
      }
    